import { render, staticRenderFns } from "./ForthStep.vue?vue&type=template&id=3ce68dc4"
import script from "./ForthStep.vue?vue&type=script&lang=js"
export * from "./ForthStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports